import React, { useEffect } from "react";
import { PersistGate } from "redux-persist/es/integration/react";
import "react-datepicker/dist/react-datepicker.css";
import { Provider, useDispatch } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { Router, Switch, Route } from "react-router-dom";
import configureStore from "./config";
import { Auth } from "./methods/auth";
import Login from "./pages/Login";
import Forgotpassword from "./pages/Forgotpassword";
import Resetpassword from "./pages/Resetpassword";
import "./scss/main.scss";
import "react-pagination-js/dist/styles.css"; // import css
import UserDetail2 from "./pages/Users2/Profiledetail"
import { ToastContainer } from "react-toastify";
import UpdateSettingsForm from "./pages/UpdateSettings";
import ChangePassword from "./components/Profile/ChangePassword/index";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import MapChart from "./pages/Dashboard2/StateGraphChart";
import Dashboard2 from "./pages/Dashboard2";
import Statistics2 from "./pages/Dashboard2/Statistics";
import CarrierPerformance2 from "./pages/PerformanceMatrix2/Html";
import DriverPerformance2 from "./pages/PerformanceMatrix2/Drivers";
import Users2 from "./pages/Users2";
import CarriersStaff2 from "./pages/CarriersStaff2";
import InvitedUser2 from "./pages/InvitedUsers2";
import Carrier2 from "./pages/Users2/CarrierIndex";
import Requests2 from "./pages/Users2/Request_Logic";
import Loads2 from "./pages/Loads2";
import Prebook_Loads2 from "./pages/Prebook-Loads2";
import RFPS_Loads2 from "./pages/RFPS-Loads2";
import PblBids from "./pages/PblBids";
import Bids2 from "./pages/Bids2";
import Notes2 from "./pages/Notes2";
import StopsNotes2 from "./pages/StopsNotes2";
import NewsLetter2 from "./pages/NewsLetter2";
import ContactQuery2 from "./pages/Queries2";
import Boards2 from "./pages/Boards2";
import Faq2 from "./pages/Faq2/Faqlisting";
import Contents2 from "./pages/ContentManagement2/html";
import ViewSettings2 from "./pages/Settings2";
import AddEditStaff2 from "./pages/Roles2/AddEditStaff";
import AddEditRole2 from "./pages/Roles2/AddEdit";
import ViewNotes2 from "./pages/Notes2/ViewNotes";
import AcceptedCarrier from "./pages/AcceptedCarrier";
import RejectCarrier from "./pages/RejectCarrier";
import ViewStopsNotes2 from "./pages/StopsNotes2/ViewNotes";
import ViewQuery2 from "./pages/Queries2/ViewQuery";
import AddEditBoards2 from "./pages/Boards2/AddEditBoards";
import BoardDetails2 from "./pages/Boards2/ViewBoard";
import Addeditfaq2 from "./pages/Faq2/Addeditfaq";
import AddeditContent2 from "./pages/ContentManagement2/AddEdit";
import LoadDetails2 from "./pages/Loads2/ViewLoads";
import BidDetails2 from "./pages/Bids2/ViewBids";
import Faqview2 from "./pages/Faq2/Faqview";
import CMSView2 from "./pages/ContentManagement2/View";
import AddEditLoad2 from "./pages/Loads2/AddEditLoads";
import Profile2 from "./pages/Profile2";
import Notifications from "./pages/Notifications";
import ContactDetails2 from "./pages/Settings2/ContactDetails";
import RateLookup from "./pages/RateLookup/RateLookup";
import LoadsListing from "./pages/Dashboard2/LogsListing";
import Analytics from "./pages/Analytics";
import AdminDocuments from "./pages/Documents";
import EmailTemplates from "./pages/EmailTemplates";
import AddEditEmailTemplate from "./pages/EmailTemplates/AddEdit";
import EmailLogs from "./pages/EmailLogs";
import Tracking from "./pages/Tracking";
import OnboardingQueue from "./pages/OnboardingQueue";
import CarrierDossier from "./pages/CarrierDossier";
import InsuranceReview from "./pages/InsuranceReview";
import CarrierAlerts from "./pages/CarrierAlerts";
import AgreementTemplates from "./pages/AgreementTemplates";
import AddEditAgreementTemplate from "./pages/AgreementTemplates/AddEdit";
import LaneIntelligence from "./pages/LaneIntelligence";
import LanePricing from "./pages/LanePricing";

/************ store configration *********/
const { persistor, store, history } = configureStore();
export { history, store };
export default () => {
  const dispatch = useDispatch();

  return (
    <>
      <PersistGate loading={"loading ..."} persistor={persistor}>
          <Router history={history}>
            <Switch>
              <Redirect exact from="/dashboard1" to="/dashboard" />
              <Redirect exact from="/dashboardpage" to="/dashboard" />
              <Route
                exact={true}
                path="/dashboard"
                store={store}
                requireAuth={Auth}
                component={Dashboard2}
              />
              <Route
                exact={true}
                path="/map"
                store={store}
                requireAuth={Auth}
                component={MapChart}
              />
              <Route
                exact={true}
                path="/edit-settings"
                store={store}
                requireAuth={Auth}
                component={ContactDetails2}
              />
              <Route
                exact={true}
                path="/settings"
                store={store}
                requireAuth={Auth}
                component={ViewSettings2}
              />
              <Route
                exact={true}
                path="/staff"
                store={store}
                requireAuth={Auth}
                component={Users2}
              />
              <Redirect exact from="/invited-users1" to="/invited-users" />
              <Route
                exact={true}
                path="/invited-users"
                store={store}
                requireAuth={Auth}
                component={InvitedUser2}
              />
              <Route
                exact={true}
                path="/carrier-users"
                store={store}
                requireAuth={Auth}
                component={CarriersStaff2}
              />
              <Route
                exact={true}
                path="/carriers"
                store={store}
                requireAuth={Auth}
                component={Carrier2}
              />
              <Route
                exact={true}
                path="/acceptedCarriers"
                store={store}
                requireAuth={Auth}
                component={AcceptedCarrier}
              />
              <Route
                exact={true}
                path="/rejectedCarriers"
                store={store}
                requireAuth={Auth}
                component={RejectCarrier}
              />
              <Redirect exact from="/carrier-requests1" to="/carrier-requests" />
              <Route
                exact={true}
                path="/carrier-requests"
                store={store}
                requireAuth={Auth}
                component={Requests2}
              />

              <Route
                exact={true}
                path="/staff/add/:pageName"
                store={store}
                requireAuth={Auth}
                component={AddEditStaff2}
              />
              <Redirect exact from="/content1/add" to="/content" />
              <Redirect exact from="/content1/edit/:id" to="/content" />
              <Route
                exact={true}
                path="/content/edit/:id"
                store={store}
                requireAuth={Auth}
                component={AddeditContent2}
              />
              <Redirect exact from="/contents1" to="/content" />
              <Route
                exact={true}
                path="/content"
                store={store}
                requireAuth={Auth}
                component={Contents2}
              />
              <Redirect exact from="/performance-carriers1" to="/performance-carriers" />
              <Route
                exact={true}
                path="/performance-carriers"
                store={store}
                requireAuth={Auth}
                component={CarrierPerformance2}
              />
              <Redirect exact from="/performance-drivers1" to="/performance-drivers" />
              <Route
                exact={true}
                path="/performance-drivers"
                store={store}
                requireAuth={Auth}
                component={DriverPerformance2}
              />
              <Redirect exact from="/content1/view/:id" to="/content" />
              <Route
                exact={true}
                path="/content/view/:id"
                store={store}
                requireAuth={Auth}
                component={CMSView2}
              />

              <Route
                exact={true}
                path="/carriers/add/:pageName"
                store={store}
                requireAuth={Auth}
                component={AddEditRole2}
              />
              <Redirect exact from="/profile1/edit" to="/profile" />

              <Redirect exact from="/boards1/add" to="/boards/add" />
              <Route
                exact={true}
                path="/boards/add"
                store={store}
                requireAuth={Auth}
                component={AddEditBoards2}
              />
              <Redirect exact from="/boards1/view/:id" to="/boards" />
              <Route
                exact={true}
                path="/notification"
                store={store}
                requireAuth={Auth}
                component={Notifications}
              />
              <Route
                exact={true}
                path="/boards/view/:id"
                store={store}
                requireAuth={Auth}
                component={BoardDetails2}
              />
              <Redirect exact from="/boards1/edit/:id" to="/boards" />
              <Route
                exact={true}
                path="/boards/edit/:id"
                store={store}
                requireAuth={Auth}
                component={AddEditBoards2}
              />
              <Redirect exact from="/boards1" to="/boards" />
              <Route
                exact={true}
                path="/boards"
                store={store}
                requireAuth={Auth}
                component={Boards2}
              />
              <Route
                exact={true}
                path="/staff/edit/:id/:pageName"
                store={store}
                requireAuth={Auth}
                component={AddEditStaff2}
              />

              <Route
                exact={true}
                path={"/newsletter"}
                store={store}
                requireAuth={Auth}
                component={NewsLetter2}
              />

              <Route
                exact={true}
                path="/carriers/edit/:id/:pageName"
                store={store}
                requireAuth={Auth}
                component={AddEditRole2}
              />

              <Route
                exact={true}
                path="/userDetail/:statusName/:id"
                store={store}
                requireAuth={Auth}
                component={UserDetail2}
              />
              <Route
                exact={true}
                path="/profile"
                store={store}
                requireAuth={Auth}
                component={Profile2}
              />
              <Redirect exact from="/loads1" to="/loads" />
              <Route
                exact={true}
                path="/loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
                <Route
                exact={true}
                store={store}
                path="/loads/:id"
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/rfps-loads1" to="/rfps-loads" />
              <Route
                exact={true}
                path="/rfps-loads"
                store={store}
                requireAuth={Auth}
                component={RFPS_Loads2}
              />
              <Route
                exact={true}
                path="/pbl-bids"
                store={store}
                requireAuth={Auth}
                component={PblBids}
              />
              <Redirect exact from="/usps-loads1" to="/usps-loads" />
              <Route
                exact={true}
                path="/usps-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/available-loads1" to="/available-loads" />
              <Route
                exact={true}
                path="/available-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/prebook-loads1" to="/prebook-loads" />
              <Route
                exact={true}
                path="/prebook-loads"
                store={store}
                requireAuth={Auth}
                component={Prebook_Loads2}
              />
              <Redirect exact from="/delivered-loads1" to="/delivered-loads" />
              <Route
                exact={true}
                path="/delivered-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/intransit-loads1" to="/intransit-loads" />
              <Route
                exact={true}
                path="/intransit-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/pendingPickup-loads1" to="/pendingPickup-loads" />
              <Route
                exact={true}
                path="/pendingPickup-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/pickedUp-loads1" to="/pickedUp-loads" />
              <Route
                exact={true}
                path="/pickedUp-loads"
                store={store}
                requireAuth={Auth}
                component={Loads2}
              />
              <Redirect exact from="/awarded-loads1" to="/loads" />
              <Redirect exact from="/loads1/view/:id" to="/loads" />
              <Route
                exact={true}
                path="/loads/view/:id"
                store={store}
                requireAuth={Auth}
                component={LoadDetails2}
              />
              <Redirect exact from="/loads1/add" to="/loads" />
              <Route
                exact={true}
                path="/loads/add/:statusData"
                store={store}
                requireAuth={Auth}
                component={AddEditLoad2}
              />
              <Redirect exact from="/loads1/edit/:id" to="/loads" />
                <Route
                exact={true}
                path="/loads/edit/:id"
                store={store}
                requireAuth={Auth}
                component={AddEditLoad2}
              />
              <Redirect exact from="/bids1" to="/bids" />
              <Route
                exact={true}
                path="/bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/pending-bids1" to="/pending-bids" />
              <Route
                exact={true}
                path="/pending-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/statistics1" to="/statistics" />
              <Route
                exact={true}
                path="/statistics"
                store={store}
                requireAuth={Auth}
                component={Statistics2}
              />
              <Route
                exact={true}
                path="/load/state"
                store={store}
                requireAuth={Auth}
                component={LoadsListing}
              />
              <Redirect exact from="/awarded-bids1" to="/awarded-bids" />
              <Route
                exact={true}
                path="/awarded-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/accepted-bids1" to="/accepted-bids" />
              <Route
                exact={true}
                path="/accepted-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/delivered-bids1" to="/delivered-bids" />
              <Route
                exact={true}
                path="/delivered-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/rejected-bids1" to="/rejected-bids" />
              <Route
                exact={true}
                path="/rejected-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Redirect exact from="/intransit-bids1" to="/intransit-bids" />
              <Route
                exact={true}
                path="/intransit-bids"
                store={store}
                requireAuth={Auth}
                component={Bids2}
              />
              <Route
                exact={true}
                path="/notes"
                store={store}
                requireAuth={Auth}
                component={Notes2}
              />
              <Route
                exact={true}
                path="/notes/:id"
                store={store}
                requireAuth={Auth}
                component={ViewNotes2}
              />
              <Route
                exact={true}
                path="/shipment-notes"
                store={store}
                requireAuth={Auth}
                component={StopsNotes2}
              />
              <Route
                exact={true}
                path="/shipment-notes/:id"
                store={store}
                requireAuth={Auth}
                component={ViewStopsNotes2}
              />
              <Redirect exact from="/bids1/view/:id" to="/bids" />
              <Route
                exact={true}
                path="/bids/view/:id/:pageName"
                store={store}
                requireAuth={Auth}
                component={BidDetails2}
              />
              {/* <Route exact={true} path="/profile/:tab" store={store} requireAuth={Auth} component={Settings} /> */}
              <Route
                exact={true}
                path="/login"
                store={store}
                requireAuth={Auth}
                component={Login}
              />
              <Route
                exact={true}
                path="/login/:id"
                store={store}
                requireAuth={Auth}
                component={Login}
              />
              <Route
                exact={true}
                path="/forgotpassword"
                store={store}
                requireAuth={Auth}
                component={Forgotpassword}
              />
              <Route
                exact={true}
                path="/resetpassword"
                store={store}
                requireAuth={Auth}
                component={Resetpassword}
              />
              <Route
                exact={true}
                path="/change-password"
                store={store}
                requireAuth={Auth}
                component={ChangePassword}
              />

              <Route
                exact={true}
                path="/queries"
                store={store}
                requireAuth={Auth}
                component={ContactQuery2}
              />

              <Route
                exact={true}
                path="/queries/view/:id"
                store={store}
                requireAuth={Auth}
                component={ViewQuery2}
              />
              <Route
                exact={true}
                path="/faq"
                store={store}
                requireAuth={Auth}
                component={Faq2}
              />
              <Route
                exact={true}
                path="/faq/add"
                store={store}
                requireAuth={Auth}
                component={Addeditfaq2}
              />
              <Route
                exact={true}
                path="/faq/edit/:id"
                store={store}
                requireAuth={Auth}
                component={Addeditfaq2}
              />

              <Route
                exact={true}
                path="/faq/view/:id"
                store={store}
                requireAuth={Auth}
                component={Faqview2}
              />
              <Route
                exact={true}
                path="/rate/lookup"
                store={store}
                requireAuth={Auth}
                component={RateLookup}
              />
              


              <Route
                exact={true}
                path="/analytics"
                store={store}
                requireAuth={Auth}
                component={Analytics}
              />
              <Route
                exact={true}
                path="/lane-intelligence"
                store={store}
                requireAuth={Auth}
                component={LaneIntelligence}
              />
              <Route
                exact={true}
                path="/lane-pricing"
                store={store}
                requireAuth={Auth}
                component={LanePricing}
              />
              <Route
                exact={true}
                path="/documents"
                store={store}
                requireAuth={Auth}
                component={AdminDocuments}
              />

              {/*  Rooute for settings */}
              <Route
                exact={true}
                path="/website/settings"
                requireAuth={Auth}
                store={store}
                component={UpdateSettingsForm}
              />

              {/* Fleet Tracking */}
              <Route
                exact={true}
                path="/tracking"
                store={store}
                requireAuth={Auth}
                component={Tracking}
              />

              {/* Carrier Onboarding */}
              <Route
                exact={true}
                path="/onboarding-queue"
                store={store}
                requireAuth={Auth}
                component={OnboardingQueue}
              />
              <Route
                exact={true}
                path="/carrier-dossier/:id"
                store={store}
                requireAuth={Auth}
                component={CarrierDossier}
              />
              <Route
                exact={true}
                path="/insurance-review"
                store={store}
                requireAuth={Auth}
                component={InsuranceReview}
              />
              <Route
                exact={true}
                path="/carrier-alerts"
                store={store}
                requireAuth={Auth}
                component={CarrierAlerts}
              />
              <Route
                exact={true}
                path="/agreement-templates"
                store={store}
                requireAuth={Auth}
                component={AgreementTemplates}
              />
              <Route
                exact={true}
                path="/agreement-template/add"
                store={store}
                requireAuth={Auth}
                component={AddEditAgreementTemplate}
              />
              <Route
                exact={true}
                path="/agreement-template/:id"
                store={store}
                requireAuth={Auth}
                component={AddEditAgreementTemplate}
              />

              {/* Email Templates */}
              <Route
                exact={true}
                path="/email-templates"
                store={store}
                requireAuth={Auth}
                component={EmailTemplates}
              />
              <Route
                exact={true}
                path="/email-templates/add"
                store={store}
                requireAuth={Auth}
                component={AddEditEmailTemplate}
              />
              <Route
                exact={true}
                path="/email-templates/edit/:id"
                store={store}
                requireAuth={Auth}
                component={AddEditEmailTemplate}
              />

              {/* Email Logs */}
              <Route
                exact={true}
                path="/email-logs"
                store={store}
                requireAuth={Auth}
                component={EmailLogs}
              />

              <Route exact path="/">
                <Redirect to="/login" />
              </Route>
            </Switch>
          </Router>
      </PersistGate>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
};
